// Detects the envrionment the application is running in based off of the
// browser location.
//
// @flow

type Environment = {
    isAlpha: boolean,
    isLocal: boolean,
    isProduction: boolean,
    isStaging: boolean
};

export const detectEnvironment = (URL: string): Environment => {
    const environment: Environment = {
        isAlpha: false,
        isLocal: false,
        isProduction: false,
        isStaging: false
    };

    // We can leverage the browser to extract the current hostname
    // we are on by using the anchor HTML element API.
    const element = document.createElement('a');
    element.href = URL;

    const hostname = element.hostname;

    // The environment is a loose match based off of
    // keyword in the hostname, and once a match has been found
    // no other matches will be attempted, and if no matches
    // are found, production is assumed.
    //
    // Furthermore we use the hostname so that URLs can contain
    // these keywords without impacting the functionality of
    // this method.
    if (hostname.includes('local')) {
        environment.isLocal = true;
    } else if (hostname.includes('alpha')) {
        environment.isAlpha = true;
    } else if (hostname.includes('staging')) {
        environment.isStaging = true;
    } else {
        environment.isProduction = true;
    }

    return environment;
};

export default function(): Environment {
    return detectEnvironment(window.location);
}



// WEBPACK FOOTER //
// ./src/lib/environmentDetection.js